import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { FAQSection } from '../../components/help/FAQSection';
import { ContactSupport } from '../../components/help/ContactSupport';
import { LiveChatWidget } from '../../components/help/LiveChatWidget';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
export function HelpCenter() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-4616">
      <Sidebar data-id="element-4617" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-4618">
        <DashboardHeader data-id="element-4619" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-4620">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-4621">
            <div className="text-center mb-8 lg:mb-10" data-id="element-4622">
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-4623">
                How can we help you?
              </h1>
              <div className="max-w-xl mx-auto relative" data-id="element-4624">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500 h-5 w-5 flex-shrink-0" data-id="element-4625" />
                <input type="text" placeholder="Search for answers..." className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 dark:border-gray-600 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent text-base bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 transition-colors" data-id="element-4626" />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-4627">
              <div className="lg:col-span-2" data-id="element-4628">
                <FAQSection data-id="element-4629" />
              </div>
              <div className="lg:col-span-1" data-id="element-4630">
                <ContactSupport data-id="element-4631" />
              </div>
            </div>
          </motion.div>
        </div>
      </main>

      <LiveChatWidget data-id="element-4632" />
    </div>;
}